import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const northTampaConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'North Tampa Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in North Tampa, FL. Sam\'s Tree Service handles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_north_tampa',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving North Tampa',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in North Tampa Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we serve the growing residential 
     communities and established neighborhoods of <strong>North Tampa</strong> 
     with expert tree care. From newer subdivisions with fast growing trees 
     crowding structures to older neighborhoods with large oaks and palms 
     that have outgrown their space, our crew handles the full range of 
     tree hazards that Florida's climate creates.`,

    `We specialize in <strong>dangerous tree removal and targeted trimming</strong> 
     storm weakened limbs over homes and driveways, trees leaning from root 
     damage, heavy canopy growth near utility lines, and full removals where 
     trees have become too risky to leave standing. Every job is done safely 
     and efficiently from start to finish.`,

    `<strong>Sam's Tree Service</strong> provides dependable, affordable tree 
     care throughout <strong>North Tampa</strong> and the broader 
     <strong>Hillsborough County</strong> area protecting your property 
     and keeping your landscape in top condition all year long.`,
  ],
  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'North Tampa, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_NorthTampa = () => <LocationPage config={northTampaConfig} />;
export default Services_NorthTampa;
